import React from "react";
import { Check, Flame } from "lucide-react";
import { OFERTA } from "@/content";
import WhatsAppButton from "@/components/WhatsAppButton";
import Reveal from "@/components/Reveal";

export default function Oferta() {
  return (
    <section
      className="relative overflow-hidden py-16 md:py-24"
      style={{ background: "linear-gradient(180deg, #6B1F3A 0%, #4A1428 100%)" }}
      data-testid="section-oferta"
    >
      <div
        className="blob"
        style={{
          width: 340,
          height: 340,
          top: 40,
          left: -120,
          background: "rgba(139,197,63,0.18)",
        }}
      />

      <div className="container-page relative z-[1]">
        <Reveal className="flex justify-center">
          <span
            className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-[13px] font-semibold"
            style={{ background: "var(--lima)", color: "#31490f" }}
          >
            <Flame size={15} strokeWidth={2.5} aria-hidden="true" />
            {OFERTA.badge}
          </span>
        </Reveal>

        <Reveal
          delay={80}
          className="mt-5 mx-auto"
          style={{ maxWidth: 640 }}
        >
          <div
            className="p-6 md:p-10"
            style={{
              background: "var(--blanco)",
              border: "2px solid var(--lima)",
              borderRadius: 24,
              boxShadow: "var(--shadow-deep)",
            }}
          >
            <h2 className="h2-display text-center" style={{ color: "var(--vino)" }}>
              {OFERTA.h2}
            </h2>

            <ul className="mt-7 space-y-3.5">
              {OFERTA.items.map((it) => (
                <li key={it.text} className="flex items-start gap-3">
                  <span
                    className="flex items-center justify-center rounded-full shrink-0 mt-0.5"
                    style={{ width: 24, height: 24, background: "var(--lima)" }}
                    aria-hidden="true"
                  >
                    <Check size={14} strokeWidth={3} color="#fff" />
                  </span>
                  <span
                    className="grow text-[15px] md:text-[16px] leading-snug"
                    style={{ color: "var(--carbon)" }}
                  >
                    {it.text}
                  </span>
                  <span
                    className="shrink-0 text-[14px] font-semibold whitespace-nowrap"
                    style={{
                      color: "var(--gris)",
                      textDecoration: it.valor === "—" ? "none" : "line-through",
                    }}
                  >
                    {it.valor}
                  </span>
                </li>
              ))}
            </ul>

            <div
              className="mt-7 p-5 text-center"
              style={{ background: "var(--lima-soft)", borderRadius: 16 }}
            >
              <p className="text-[14px] font-semibold" style={{ color: "var(--gris)" }}>
                {OFERTA.cierreValor}
              </p>
              <p
                className="font-display mt-1"
                style={{ fontSize: 24, color: "var(--vino)" }}
              >
                {OFERTA.cierreLinea}
              </p>
              <p
                className="mt-3 text-[15px] leading-snug"
                style={{ color: "var(--carbon)" }}
              >
                {OFERTA.cierreFrase}
              </p>
            </div>

            <div className="mt-7">
              <WhatsAppButton section="oferta" size="lg" full />
              <p
                className="mt-3 text-[13px] text-center"
                style={{ color: "var(--gris)" }}
              >
                {OFERTA.micro}
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
